module.exports = __webpack_public_path__ + "img/DE00503.638b4814.png";